import { render, staticRenderFns } from "./WatchVideo.vue?vue&type=template&id=0a026666&scoped=true"
import script from "./WatchVideo.vue?vue&type=script&lang=js"
export * from "./WatchVideo.vue?vue&type=script&lang=js"
import style0 from "./WatchVideo.vue?vue&type=style&index=0&id=0a026666&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a026666",
  null
  
)

export default component.exports